import axios from "axios";

// export const baseURL = `https://photokeyboard.app`;
export const baseURL = process.env.REACT_APP_API_BASE_URL;
export const superAppBaseURL = process.env.REACT_APP_SUPER_API_BASE_URL;


// ADMIN INSTANCE
const API = axios.create({ baseURL: `${baseURL}/v1` });
API.interceptors.request.use((req) => {
    let token = localStorage.getItem('token');
    if (token) {
        req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
});

const SUPER_API = axios.create({ baseURL: `${superAppBaseURL}` });
SUPER_API.interceptors.request.use((req) => {
    let token = localStorage.getItem('token');
    if (token) {
        req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
});


// ADMIN APIS
export const adminSignin = async (payload) => API.post(`/admin/signIn`, payload);
export const ldapadminSignin = async (payload) => SUPER_API.post(`/admin/loginWithLdap`, payload);
export const checkUserPermissions = async (project_id) => SUPER_API.post(`/admin/checkUserPermissions/${project_id}`);
// MUSIC 
export const addMusic = async (payload) => API.post(`/admin/addMusic`, payload);
export const updateMusic = async (payload, id) => API.patch(`/admin/updateMusic?id=${id}`, payload);
export const updateMusicPriority = async (payload) => API.patch(`/admin/updateMusicPriority`, payload);
export const deleteMusic = async (id) => API.delete(`/admin/deleteMusic?id=${id}`);
export const deleteAllMusic = async (payload) => API.post(`/admin/deleteAllMusic`, payload);
export const getMusic = async (_search, _filterDropdown, sortName, sortType) => {
    // if (_currentPage || _perPage || _search || _filterDropdown) {
    if (_search || _filterDropdown || sortName || sortType) {
        // return API.post(`/admin/getMusic?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
        return API.post(`/admin/getMusic?search=${_search}&sortName=${sortName}&sortType=${sortType}`, _filterDropdown)
    } else {
        return API.post(`/admin/getMusic`)
    }
};

// Stickers 
export const addStickers = async (payload) => API.post(`/admin/addStickers`, payload);
export const updateStickers = async (payload, id) => API.patch(`/admin/updateStickers?id=${id}`, payload);
export const deleteStickers = async (id) => API.delete(`/admin/deleteStickers?id=${id}`);
export const deleteAllStickers = async (payload) => API.post(`/admin/deleteAllStickers`, payload);
export const getStickers = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
        return API.post(`/admin/getStickers?page=${_currentPage}&perPage=${_perPage}&search=${_search}&sortName=${sortName}&sortType=${sortType}`, _filterDropdown)
    } else {
        return API.post(`/admin/getStickers`)
    }
};


// Stickers Tag
export const addStickerTags = async (payload) => API.post(`/admin/addStickerTags`, payload);
export const updateStickerTags = async (payload, id) => API.patch(`/admin/updateStickerTags?id=${id}`, payload);
export const deleteStickerTags = async (id) => API.delete(`/admin/deleteStickerTags?id=${id}`);
export const deleteAllStickerTags = async (payload) => API.post(`/admin/deleteAllStickerTags`, payload);
export const getStickerTags = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
        return API.post(`/admin/getStickerTags?page=${_currentPage}&perPage=${_perPage}&search=${_search}&sortName=${sortName}&sortType=${sortType}`, _filterDropdown)
    } else {
        return API.post(`/admin/getStickerTags`)
    }
};


// feedback
export const addFeedback = async (payload) => API.post(`/admin/addFeedback`, payload);
export const updateFeedback = async (payload, id) => API.patch(`/admin/updateFeedback?id=${id}`, payload);
export const deleteFeedback = async (id) => API.delete(`/admin/deleteFeedback?id=${id}`);
export const deleteAllFeedback = async (payload) => API.post(`/admin/deleteAllFeedback`, payload);
export const getFeedbackDropDownList = async () => API.get(`/admin/getFeedbackDropDownList`);
export const downloadFeedbackExcel = async (_filterDropdown, _search, startDate, endDate) => {
    if (_filterDropdown || _search || startDate || endDate) {
        const queryParams = JSON.stringify(_filterDropdown);
        return API.get(`/admin/exportFeedback?search=${_search}&startDate=${startDate}&endDate=${endDate}&filterDropdown=${queryParams}`, { responseType: 'arraybuffer' })
    } else {
        return API.get(`/admin/exportFeedback`, { responseType: 'arraybuffer' });
    }
}
export const getFeedback = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType, startDate, endDate) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType || startDate || endDate) {
        return API.post(`/admin/getFeedback?page=${_currentPage}&perPage=${_perPage}&search=${_search}&sortName=${sortName}&sortType=${sortType}&startDate=${startDate}&endDate=${endDate}`, _filterDropdown)
    } else {
        return API.post(`/admin/getFeedback`)
    }
};

// UserFeedback
export const getUserFeedback = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType, startDate, endDate) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType || startDate || endDate) {
        return API.post(`/admin/getUserFeedback?page=${_currentPage}&perPage=${_perPage}&search=${_search}&sortName=${sortName}&sortType=${sortType}&startDate=${startDate}&endDate=${endDate}`, _filterDropdown)
    } else {
        return API.post(`/admin/getUserFeedback`)
    }
};

// Rating
export const addRating = async (payload) => API.post(`/admin/addRating`, payload);
export const updateRating = async (payload, id) => API.patch(`/admin/updateRating?id=${id}`, payload);
export const deleteRating = async (id) => API.delete(`/admin/deleteRating?id=${id}`);
export const deleteAllRating = async (payload) => API.post(`/admin/deleteAllRating`, payload);
export const getRatingDropDownList = async () => API.get(`/admin/getRatingDropDownList`);
export const getRating = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType, startDate, endDate) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType || startDate || endDate) {
        return API.post(`/admin/getRating?page=${_currentPage}&perPage=${_perPage}&search=${_search}&sortName=${sortName}&sortType=${sortType}&startDate=${startDate}&endDate=${endDate}`, _filterDropdown)
    } else {
        return API.post(`/admin/getRating`)
    }
};
export const downloadRatingExcel = async (_filterDropdown, _search, startDate, endDate) => {
    if (_filterDropdown || _search || startDate || endDate) {
        const queryParams = JSON.stringify(_filterDropdown);
        return API.get(`/admin/exportRating?search=${_search}&startDate=${startDate}&endDate=${endDate}&filterDropdown=${queryParams}`, { responseType: 'arraybuffer' })
    } else {
        return API.get(`/admin/exportRating`, { responseType: 'arraybuffer' });
    }
};


// feedback category
export const addFeedbackCategory = async (payload) => API.post(`/admin/addFeedbackCategory`, payload);
export const updateFeedbackCategory = async (payload, id) => API.patch(`/admin/updateFeedbackCategory?id=${id}`, payload);
export const updateFeedbackCategoryPriority = async (payload) => API.patch(`/admin/updateFeedbackCategoryPriority`, payload);
export const deleteFeedbackCategory = async (id) => API.delete(`/admin/deleteFeedbackCategory?id=${id}`);
export const deleteAllFeedbackCategory = async (payload) => API.post(`/admin/deleteAllFeedbackCategory`, payload);
export const updateFeedbackCategorySetting = async (payload) => API.post(`/admin/addFeedbackCategorySetting`, payload);
export const getFeedbackCategorySetting = async () => API.post(`/admin/getFeedbackCategorySetting`);
export const getFeedbackCategory = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
        return API.post(`/admin/getFeedbackCategory?page=${_currentPage}&perPage=${_perPage}&search=${_search}&sortName=${sortName}&sortType=${sortType}`, _filterDropdown)
    } else {
        return API.post(`/admin/getFeedbackCategory`)
    }
};


// feedback Sub category
export const addFeedbackSubCategory = async (payload) => API.post(`/admin/addFeedbackSubCategory`, payload);
export const updateFeedbackSubCategory = async (payload, id) => API.patch(`/admin/updateFeedbackSubCategory?id=${id}`, payload);
export const updateFeedbackSubCategoryPriority = async (payload) => API.patch(`/admin/updateFeedbackSubCategoryPriority`, payload);
export const deleteFeedbackSubCategory = async (id) => API.delete(`/admin/deleteFeedbackSubCategory?id=${id}`);
export const deleteAllFeedbackSubCategory = async (payload) => API.post(`/admin/deleteAllFeedbackSubCategory`, payload);
export const getFeedbackSubCategory = async (_payload) => {
    // if (_currentPage || _perPage || _search || _filterDropdown) {
    //     return API.post(`/admin/getFeedbackSubCategory?page=${_currentPage}&perPage=${_perPage}&search=${_search}`, _filterDropdown)
    // } else {
    return API.post(`/admin/getFeedbackSubCategory`, _payload)
    // }
};


//Blogs categories
export const get_Blog_categories = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
        const searchData = _search.trim();
        return API.post(`/admin/getCategories?page=${_currentPage}&perPage=${_perPage}&search=${searchData}&sortName=${sortName}&sortType=${sortType}`, _filterDropdown)
    } else {
        return API.post(`/admin/getCategories`)
    }
}
export const add_Blog_categories = async (payload) => API.post(`/admin/addCategories`, payload);
export const update_Blog_categories = async (payload, id) => API.patch(`/admin/updateCategories?id=${id}`, payload);
export const delete_Blog_categories = async (id) => API.delete(`/admin/deleteCategories?id=${id}`);
export const deleteAll_Blog_categories = async (payload) => API.post(`/admin/deleteAllCategories`, payload);


//Blogs 
export const get_Blog = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
        const searchData = _search.trim();
        return API.post(`/admin/getBlogs?page=${_currentPage}&perPage=${_perPage}&search=${searchData}&sortName=${sortName}&sortType=${sortType}`, _filterDropdown)
    } else {
        return API.post(`/admin/getBlogs`)
    }
}
export const getOne_Blog = async (id) => API.get(`/admin/getOneBlog?slug=${id}`);
export const add_Blog = async (payload) => API.post(`/admin/addBlogs`, payload);
export const update_Blog = async (payload, id) => API.patch(`/admin/updateBlogs?id=${id}`, payload);
export const delete_Blog = async (id) => API.delete(`/admin/deleteBlogs?id=${id}`);
export const deleteAll_Blog = async (payload) => API.post(`/admin/deleteAllBlogs`, payload);
export const addSetting = async (payload) => API.post(`/admin/addSetting`, payload);


//Blogs Comments
export const get_Blog_Comments = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
        const searchData = _search.trim();
        return API.post(`/admin/getReply?page=${_currentPage}&perPage=${_perPage}&search=${searchData}&sortName=${sortName}&sortType=${sortType}`, _filterDropdown)
    } else {
        return API.post(`/admin/getReply`)
    }
}
export const delete_Reply = async (id) => API.delete(`/admin/deleteReply?id=${id}`);
export const deleteAll_Reply = async (payload) => API.post(`/admin/deleteAllReply`, payload);

export const addSubscriptions = async (payload) => API.post(`/admin/uploadSubscriptionImage`, payload);
export const getSubscriptions = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
        return API.get(`/admin/getSubscriptionImage?page=${_currentPage}&perPage=${_perPage}&search=${_search}&sortName=${sortName}&sortType=${sortType}`, _filterDropdown)
    } else {
        return API.get(`/admin/getSubscriptionImage`)
    }
};

//FAQ
export const getFAQ = async (_filterDropdown) => {
    if (_filterDropdown) {
        return API.post(`/admin/getFaq`, _filterDropdown);
    } else {
        return API.post(`/admin/getFaq`);
    }
};
export const getOneFAQ = async (id) => {
    return API.get(`/admin/getOneFAQ?id=${id}`);
};
export const addFAQ = async (payload) => API.post(`/admin/addFaq`, payload);
export const updateFAQ = async (payload, id) =>
    API.patch(`/admin/updateFaq?id=${id}`, payload);
export const deleteFAQ = async (id) => API.delete(`/admin/deleteFaq?id=${id}`);

export const deleteMediaFAQ = async (payload) =>
    API.post(`/admin/deleteMediaFaq`, payload);

export const deleteAllFAQ = async (payload) =>
    API.delete(`/admin/deleteAllFaq`, payload);

export const updateFaqPriority = async (payload) =>
    API.post(`/admin/updateFaqPriority`, payload);
export const updateFaqMediaPriority = async (payload) =>
    API.post(`/admin/updateFaqMediaPriority`, payload);


export const deleteSubscription = async (id) => API.delete(`/admin/deleteSubscriptionImage?id=${id}`);

// Asset
// asset
export const addAsset = async (payload) => API.post(`/admin/addAsset`, payload);

export const getAsset = async (_currentPage,
    _perPage) => {
    if (_currentPage || _perPage) {
        return API.post(
            `/admin/getAsset?page=${_currentPage}&perPage=${_perPage}`
        );
    } else {
        return API.post(`/admin/getAsset`);
    }

};

export const updateAsset = async (payload, id) =>
    API.post(`/admin/updateAsset?id=${id}`, payload);

export const deleteAsset = async (id) => API.delete(`/admin/deleteAsset?id=${id}`);

export const getAssetLink = async () => {
    return API.post(`/admin/getAssetLink`);
};
export const getEncodingString = async (payload) => {
    return API.post(`/admin/getEncodingString`, payload);
};

// Bank Regex
export const addBankDetail = async (payload) => API.post(`/bank/addBankDetails`, payload);

// export const getBankRegex = async (payload) => {
//     return API.post(`/bank/getBankDetails`, payload);
// };

export const getBankRegex = async (_currentPage, _perPage, _search, sortName, sortType) => {
    if (_currentPage || _perPage || _search || sortName || sortType) {
        return API.post(`/bank/getBankDetails?page=${_currentPage}&perPage=${_perPage}&search=${_search}&sortName=${sortName}&sortType=${sortType}`)
    } else {
        return API.post(`/bank/getBankDetails`)
    }
};

export const updateRegex = async (payload, id) =>
    API.patch(`/bank/updateBankDetails?id=${id}`, payload);

export const deleteBankRegex = async (id) => API.delete(`/bank/deleteBankDetails?id=${id}`);

// SMS Regex
export const addBankRegex = async (payload) => API.post(`/bankRegex/addBankRegexDetails`, payload);

// export const getSmsRegex = async (payload) => {
//     return API.post(`/bankRegex/getBankRegexDetails`, payload);
// };

export const getSmsRegex = async (_currentPage, _perPage, _search, sortName, sortType) => {
    if (_currentPage || _perPage || _search || sortName || sortType) {
        return API.post(`/bankRegex/getBankRegexDetails?page=${_currentPage}&perPage=${_perPage}&search=${_search}&sortName=${sortName}&sortType=${sortType}`)
    } else {
        return API.post(`/bankRegex/getBankRegexDetails`)
    }
};

export const updateSmsRegex = async (payload, id) =>
    API.patch(`/bankRegex/updateBankRegexDetails?id=${id}`, payload);

export const deleteSmsRegex = async (id) => API.delete(`/bankRegex/deleteBankRegexDetails?id=${id}`);
// API Response 
export const getBankData = async (payload, countryCode) => API.get(`/bankRegex/getAllBankData?countryCode=${countryCode}`, payload);



// Themes 
export const addThemes = async (payload) => API.post(`/admin/addTheme`, payload);
export const updateThemes = async (payload, id) => API.post(`/admin/updateTheme?id=${id}`, payload);
export const deleteThemes = async (id) => API.delete(`/admin/deleteTheme?id=${id}`);
export const deleteAllThemes = async (payload) => API.post(`/admin/deleteAllTheme`, payload);

export const getThemes = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
        return API.post(`/admin/getTheme?page=${_currentPage}&perPage=${_perPage}&search=${_search}&sortName=${sortName}&sortType=${sortType}`, _filterDropdown)
    } else {
        return API.post(`/admin/getTheme`)
    }
};
export const updateThemesPriority = async (payload) =>
    API.post(`/admin/updateThemePriority`, payload);

// wallpapers 
export const addWallpapers = async (payload) => API.post(`/admin/addThemeWallPaper`, payload);
export const updateWallpapers = async (payload, id) => API.post(`/admin/updateThemeWallpaper?id=${id}`, payload);
export const deleteWallpapers = async (id) => API.delete(`/admin/deleteThemeWallpaper?id=${id}`);
export const deleteAllWallpapers = async (payload) => API.post(`/admin/deleteAllThemWallpaper`, payload);

export const getWallpapers = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
        return API.post(`/admin/getThemeWallpaper?page=${_currentPage}&perPage=${_perPage}&search=${_search}&sortName=${sortName}&sortType=${sortType}`, _filterDropdown)
    } else {
        return API.post(`/admin/getThemeWallpaper`)
    }
};
export const updateWallpaperPriority = async (payload) =>
    API.post(`/admin/updateThemeWallpaperPriority`, payload);


// Bubbles 
export const addBubbles = async (payload) => API.post(`/admin/addThemeBubble`, payload);
export const updateBubbles = async (payload, id) => API.post(`/admin/updateThemeBubble?id=${id}`, payload);
export const deleteBubbles = async (id) => API.delete(`/admin/deleteThemeBubble?id=${id}`);
export const deleteAllBubbles = async (payload) => API.post(`/admin/deleteAllThemeBubble`, payload);

export const getBubbles = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
        return API.post(`/admin/getThemeBubble?page=${_currentPage}&perPage=${_perPage}&search=${_search}&sortName=${sortName}&sortType=${sortType}`, _filterDropdown)
    } else {
        return API.post(`/admin/getThemeBubble`)
    }
};
export const updateBubblePriority = async (payload) =>
    API.post(`/admin/updateThemeBubblePriority`, payload);




// font 
export const addFont = async (payload) => API.post(`/admin/addThemeFont`, payload);
export const updateFont = async (payload, id) => API.post(`/admin/updateThemeFont?id=${id}`, payload);
export const deleteFont = async (id) => API.delete(`/admin/deleteThemeFont?id=${id}`);
export const deleteAllFont= async (payload) => API.post(`/admin/deleteAllThemeFont`, payload);

export const getFont = async (_currentPage, _perPage, _search, _filterDropdown, sortName, sortType) => {
    if (_currentPage || _perPage || _search || _filterDropdown || sortName || sortType) {
        return API.post(`/admin/getThemeFont?page=${_currentPage}&perPage=${_perPage}&search=${_search}&sortName=${sortName}&sortType=${sortType}`, _filterDropdown)
    } else {
        return API.post(`/admin/getThemeFont`)
    }
};

export const updateFontPriority = async (payload) =>
    API.post(`/admin/updateThemeFontPriority`, payload);

